module.exports = __webpack_public_path__ + "img/cj.6a212c0f.png";